import {useRef} from "react";
import { useState, useEffect } from 'react';
import ChartComponent from '../../../../components/chart';
import LoadingComponent from '../../../../components/loading';
import Api from "../../../../services/api";
import {getColor} from '../../../../utility';
import ReChartComponent from "../../../../components/chartNew";

const AppRetentionPerformance = (props) => {
  const [appRetentionPerformance,setAppRetentionPerformance] = useState([]);
  const [appRetentionPerformanceData,setAppRetentionPerformanceData] = useState({
    labels : [],
    datasets : []
  });
  const [loading,setLoading] = useState(false);
  const prevParamsRef = useRef("");
  // const AppRetentionPerformanceOptions = {
  //   plugins: {
  //     legend: {
  //       position: 'bottom',
  //     },
  //   },
  //   scales: {
  //     y: {
  //       position : 'left',
  //       // title: {
  //       //   display: true,
  //       //   text: 'Dollar'
  //       // }
  //     },
  //     y1: {
  //       position : 'right',
  //     },
  //   },
  //   responsive: true,
  //   interaction: {
  //     intersect: false,
  //     axis: 'x'
  //   },
  // };

  const AppRetentionPerformanceOptions = {
    indexAxis: 'x',
    legend: true,
    multi: true
  };

  useEffect(() => {
    const currentParams = JSON.stringify({
      os: props.os,
      from: props.startDate.format('YYYY-MM-DD'),
      to: props.endDate.format('YYYY-MM-DD'),
      code: props.code,
      country: props.country,
      ad_network: props.adnetwork,
      campaign: props.campaign,
      index_filter: props.filter
    });

    if (prevParamsRef.current === currentParams) return;

    prevParamsRef.current = currentParams;

    setLoading(true)
    Api.get(`api/overview_app/retention_performance?os=${props.os}&from=${props.startDate.format('YYYY-MM-DD')}&to=${props.endDate.format('YYYY-MM-DD')}&code=${props.code}&country=${props.country}&ad_network=${props.adnetwork}&campaign=${props.campaign}&index_filter=${props.filter}`)
        .then(result => {
          if(result?.data?.code === 0){
            setAppRetentionPerformance(result.data.data)
            setLoading(false)
          }
        });
  }, [props.code,props.os,props.reload,props.filter]);

  const fixedColors = {
    'install': '#007d00',
    'retention': '#DB4437',
    'roas': '#F4B400',
  };

  useEffect(() => {
    let labels = [];
    let datasets = [];
    
    Object.entries(appRetentionPerformance).map(([k,i]) => {
      labels.push(k)
      i.map((i1,k1) => {
        const color = fixedColors[i1.key] || getColor(k1);

        if(datasets[i1.key] === undefined){
          if(i1.key === 'install'){
            datasets[i1.key] = {
              label : i1.name,
              data : [],
              yAxisID : 'y',
              backgroundColor : color,
              barThickness : 30,
              type: 'bar',
              order: 2
            }
          }else{
            datasets[i1.key] = {
              label : i1.name,
              data : [],
              yAxisID : 'y1',
              type: 'line',
              backgroundColor : color,
              borderColor: color,
              borderWidth: 2,
              fill: false,
              order: 1
            }
          }
        }
        datasets[i1.key].data.push(i1.value);
      })
    })
    setAppRetentionPerformanceData({labels,datasets : Object.values(datasets)})
    
  }, [appRetentionPerformance]);

  return (
      <>
        <LoadingComponent loading={loading} />
        {/* <ChartComponent type="bar" data={appRetentionPerformanceData} options={AppRetentionPerformanceOptions} /> */}
        <ReChartComponent type="bar" data={appRetentionPerformanceData} options={AppRetentionPerformanceOptions} />
      </>
  )
}
export default AppRetentionPerformance;